<select-component
	[items]="items"
	[value]="selectedAddress ? selectedAddress.id : 0"
	(valueChange)="handleAddressChange($event)"
></select-component>
